module.exports = __webpack_public_path__ + "media/components/country-flag/static/ve-d358f3427b172795014e958354ad7dc4.svg";